import { render, staticRenderFns } from "./NewsCategoryDelete.vue?vue&type=template&id=ae293698&scoped=true&"
import script from "./NewsCategoryDelete.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae293698",
  null
  
)

export default component.exports